// extracted by mini-css-extract-plugin
module.exports = {"graphLoaderIcon":"TopNRecordsLineGraph_graphLoaderIcon__2hdH8 Graphs_graphLoaderIcon__rCc2Q"};